(function () {
    'use strict';

    angular
        .module('app.accountManagement')
        .controller('AccountManagementController', AccountManagementController);

    AccountManagementController.$inject = ['Keepalive','$scope', '$cookies', '$state', '$modal', 'authentication', 'moment', 'Idle', 'config'];

    function AccountManagementController(Keepalive, $scope, $cookies, $state, $modal, authentication, moment, Idle, config) {
        var vm = this;

        vm.websiteFamilyList = null;
        vm.footerMessage = null;
        vm.isUatWebsite = null;
        vm.contactHelpDeskUrl = 'https://contact.armyfamilywebportal.com';

        vm.showMenu = false;

        vm.navClosed = false;

        vm.isLoggedIn = false;
        vm.lastLoginDate = null;

        vm.isAdmin = false;
        vm.isAfwpAdmin = false;

        vm.onClickLogOut = onClickLogOut;
        vm.onClickManageUsers = onClickManageUsers;
        vm.logIn = logIn;
        vm.register = register;
        vm.goHome = goHome;
        vm.onClickViewProfile = onClickViewProfile;
        vm.openAboutModal = openAboutModal;
        vm.toggleNav = toggleNav;

        $scope.$on('IdleStart', function () {
            // the user appears to have gone idle
            return $modal.open({
                templateUrl: 'app/components/idle/idle.view.html',
                controller: 'IdleController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'tiny',
                closeOnClick: false,
                keyboard: false
            }).result.then(function () {
                Idle.watch();
                $cookies.remove('logged-out-reason');
            });
        });

        $scope.$on('IdleTimeout', function () {
            // the user has timed out (meaning idleDuration + timeout has passed without any activity)
            // this is where you'd log them
            config.get().then(function (configData) {
                $cookies.put('logged-out-reason', configData.loggedOutReasons.idle);
                logOutOfAppOnly();
                $state.go('accountManagement.loggedOut', null, { reload: true });
            });
        });

        $scope.$on('Keepalive', function () {
            // do something to keep the user's session alive
            authentication.keepAlive().catch(function (err) {
                console.error(err);
                return config.get().then(function (configData) {
                    $cookies.put('logged-out-reason', configData.loggedOutReasons.ticketError);
                    logOut();
                });
            });
        });

        vm.classList = [
            'afwp-home',
            'efmp-blue',
            'acs-green',
            'vmis-teal',
            'ims-red',
            'olms-orange',
            'vfrg-blue'];

        for (var website in vm.websiteFamilyList) {
            vm.websiteFamilyList[website].color = vm.classList[website];
        }

        $scope.$on('profile:update', function () {
            // Update the name and side nav options
            activate();
        });

        // TODO: Reimplement Idle service triggers, if needed.

        activate();

        function activate() {
            config.get().then(function (configData) {
                vm.websiteFamilyList = configData.afwpWebsiteFamilyList;
                vm.footerMessage = configData.footerMessage || "";
                vm.isUatWebsite = configData.isUatWebsite;

                let options = vm.websiteFamilyList
                    .filter(e => e.name === 'AFWP Resource Center')
                    .map(e => e.url);

                // If "/about", open About modal on blank page that can't be closed.
                if ($state.current.name === 'about') {
                    openAboutModal(true);
                }
                else if (authentication.isLoggedIn() && $state.current.name !== 'accountManagement.loggedOut') {
                    vm.isLoggedIn = true;

                    authentication.getCasInfoForUser(authentication.getEmail()).then(function (casInfo) {
                        vm.isAdmin = casInfo.user.admin;
                    }).then(authentication.getUserProfile).then(function (userInfo) {
                        vm.firstName = userInfo.aosUser.firstName;
                        for (var i = 0; i < userInfo.aosUser.aosRoles.length; i++) {
                            if (userInfo.aosUser.aosRoles[i] === "AFWP Administrator") {
                                vm.isAfwpAdmin = true;
                            }
                        }
                        //Changing timeout based on admin
                        if(vm.isAdmin || vm.isAfwpAdmin){
                            Idle.setIdle(configData.adminIdleConfig.idle);
                            console.log('admin')
                            // Seconds to wait after a user is idle to perfom some action (e.g. log out the user).
                            Idle.setTimeout(configData.adminIdleConfig.timeout);
                            // Interval to send a keep alive signal to the backend.
                            Keepalive.setInterval(configData.adminIdleConfig.keepAlive);
                        }
                        else{
                            console.log('not admin')
                            // Seconds to wait until a user is considered idle.
                            Idle.setIdle(configData.idleConfig.idle);
                            // Seconds to wait after a user is idle to perfom some action (e.g. log out the user).
                            Idle.setTimeout(configData.idleConfig.timeout);
                            // Interval to send a keep alive signal to the backend.
                            Keepalive.setInterval(configData.idleConfig.keepAlive);
                        }
                    });
                    getLastLoginDate().catch(function (error) {
                        console.log(error);
                    });
                }
                else {
                    vm.isLoggedIn = false;
                }

                vm.isLoading = false;
            });
        }

        function onClickManageUsers() {
            manageUsers();
        }

        function getLastLoginDate() {
            return authentication.getLastLoginDate()
                .then(function (response) {
                    if (response.lastLoginDate == null){
                        vm.lastLoginDate = null;
                    } else {
                        vm.lastLoginDate = moment(response.lastLoginDate).local().format('MM-DD-YYYY, h:mm A');
                    }
                }).catch(function (err) {
                    throw(err);
                });
        }

        function onClickLogOut() {
            vm.isDropdownOpen = false;
            return logOut();
        }

        function logOut() {
            Idle.unwatch();
            authentication.logOut().catch(function (err) {
                console.error(err);
                return config.get().then(function (configData) {
                    $cookies.put('logged-out-reason', configData.loggedOutReasons.ticketError);
                });
            });
        }

        function logOutOfAppOnly() {
            Idle.unwatch();
            authentication.logOutOfAppOnly().catch(function (err) {
                console.error(err);
                return config.get().then(function (configData) {
                    $cookies.put('logged-out-reason', configData.loggedOutReasons.idle);
                });
            });
        }

        function onClickViewProfile() {
            vm.isDropdownOpen = false;
            $state.go('accountManagement.profile');
        }

        function goHome() {
            $state.go('accountManagement.dashboard');
        }

        function logIn() {
            $state.go('accountManagement.logIn');
        }

        function register() {
            return $state.go('accountManagement.register', null, { reload: true });
        }

        function manageUsers() {
            return $state.go('accountManagement.manageUsers', null, { reload: true });
        }

        // Close the dropdown menu if the user clicks outside of it
        window.onclick = function (event) {
            if (!$(event.target).hasClass("header-icon-menu")) {
                vm.showMenu = false;
                $scope.$apply();
            }
        };

        function openAboutModal(stayOpen) {
            var options = {
                templateUrl: "app/components/about/about.modal.view.html",
                controller: 'AboutModalController',
                controllerAs: 'aboutModal',
                backdrop: 'static',
                keyboard: 'false',
                show: true,
                resolve: {
                    // Tell modal to hide close buttons
                    stayOpen: function () {
                        return stayOpen;
                    }
                }
            };

            // Keep modal open despite clicks or "Escape" press
            if (stayOpen === true) {
                options.backdrop = 'static';
                options.keyboard = false;
            }

            return $modal.open(options)
                .result.catch(function (error) {
                    if (error === 'cancel' || error === 'ok' || error === 'backdrop click')
                        return;
                    if (error)
                        console.error(error);
                });
        }

        /* This function is accessible by a round button when the side nav is closed
        * and the last side nav entry when it is open.
        * The side nav entry only shows when on medium or small screens, and the side nav
        * always starts open. So this functionality isn't accessible on large screens.
        * (This can be changed! Just remove "hide-for-large" for that entry in accountManagement.view.html.) */
        function toggleNav() {
            vm.navClosed = !vm.navClosed;
        }
    }
})();